import "./src/styles/global.css"
import React from "react"
import ClientOnlyBackendProvider from "./src/services/backend/backend-provider"

// ES5 way
// exports.onClientEntry = () => {
// ES6 way
export const onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (!(`IntersectionObserver` in window)) {
    import(`intersection-observer`)
  }
}

export const wrapRootElement = ({ element }) => {
  return (
    <ClientOnlyBackendProvider>
      {element}
    </ClientOnlyBackendProvider>
  )
}